import React from "react";
import data from "../../data/home1-rtl/projects/projects1";
function Projects() {
  const all = [...data.interior, ...data.construction];
  const featured = Object.values(data)
    .flat()
    .filter((project) => project.sub1 === "مميز" || project.sub2 === "مميز");
  const interior = data.interior;
  const construction = data.construction;

  return (
    <section id="projects" className="tc-projects-style1">
      <div className="container">
        <div className="title mb-70 pt-50">
          <h2 className="fsz-45"> مشاريعنا </h2>
        </div>
        <div className="tabs-links mb-50">
          <div className="row align-items-center">
            <div className="col-lg-9">
              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-proj-all-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-proj-all"
                    type="button"
                    role="presentation"
                  >
                    الكل
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-proj-featured-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-proj-featured"
                    type="button"
                    role="presentation"
                  >
                    المميز
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-proj-interior-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-proj-interior"
                    type="button"
                    role="presentation"
                  >
                    تصميم وتنفيذ داخلى
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-proj-construction-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-proj-construction"
                    type="button"
                    role="presentation"
                  >
                    إنشاء
                  </button>
                </li>
              </ul>
            </div>
            {/* <div className="col-lg-3 mt-4 mt-lg-0 text-lg-end">
              <a
                href="#"
                className="butn border rounded-pill color-orange1 border-orange1 hover-bg-orange1"
              >
                <span>
                  شاهد جميع المشاريع
                  <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a>
            </div> */}
          </div>
        </div>
        <div className="projects">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-proj-all"
              role="tabpanel"
              aria-labelledby="pills-proj-all-tab"
            >
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {all.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <a
                            href={item.img}
                            className="img"
                            data-fancybox={`proj-all-${i}`}
                          >
                            <img src={item.img} alt="" className="img-cover" />
                          </a>

                          <div className="info">
                            <div className="tags">
                              <a href="#"> {item.sub1} </a>
                              {item.sub2 ? <a href="#"> {item.sub2} </a> : null}
                            </div>
                            <h3 className="title">
                              <a href="#"> {item.title} </a>
                            </h3>
                            <div className="text">{item.desc}</div>
                          </div>

                          {item.imgs.map((img, index) => (
                            <a
                              key={`proj-all-${i}-${index}`}
                              href={img}
                              className="img"
                              data-fancybox={`proj-all-${i}`}
                              style={{ display: "none" }}
                            >
                              <img
                                src={img}
                                alt=""
                                className="img-cover"
                                loading="lazy"
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">
                  اضغط <br /> واسحب
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="pills-proj-featured"
              role="tabpanel"
              aria-labelledby="pills-proj-featured-tab"
            >
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {featured.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <a
                            href={item.img}
                            className="img"
                            data-fancybox={`proj-featured-${i}`}
                          >
                            <img src={item.img} alt="" className="img-cover" />
                          </a>

                          <div className="info">
                            <div className="tags">
                              <a href="#"> {item.sub1} </a>
                              {item.sub2 ? <a href="#"> {item.sub2} </a> : null}
                            </div>
                            <h3 className="title">
                              <a href="#"> {item.title} </a>
                            </h3>
                            <div className="text">{item.desc}</div>
                          </div>

                          {item.imgs.map((img, index) => (
                            <a
                              key={`proj-featured-${i}-${index}`}
                              href={img}
                              className="img"
                              data-fancybox={`proj-featured-${i}`}
                              style={{ display: "none" }}
                            >
                              <img
                                src={img}
                                alt=""
                                className="img-cover"
                                loading="lazy"
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">
                  اضغط <br /> واسحب
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="pills-proj-interior"
              role="tabpanel"
              aria-labelledby="pills-proj-interior-tab"
            >
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {interior.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <a
                            href={item.img}
                            className="img"
                            data-fancybox={`proj-interior-${i}`}
                          >
                            <img src={item.img} alt="" className="img-cover" />
                          </a>

                          <div className="info">
                            <div className="tags">
                              <a href="#"> {item.sub1} </a>
                              {item.sub2 ? <a href="#"> {item.sub2} </a> : null}
                            </div>
                            <h3 className="title">
                              <a href="#"> {item.title} </a>
                            </h3>
                            <div className="text">{item.desc}</div>
                          </div>

                          {item.imgs.map((img, index) => (
                            <a
                              key={`proj-interior-${i}-${index}`}
                              href={img}
                              className="img"
                              data-fancybox={`proj-interior-${i}`}
                              style={{ display: "none" }}
                            >
                              <img
                                src={img}
                                alt=""
                                className="img-cover"
                                loading="lazy"
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">
                  اضغط <br /> واسحب
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="pills-proj-construction"
              role="tabpanel"
              aria-labelledby="pills-proj-construction-tab"
            >
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {construction.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <a
                            href={item.img}
                            className="img"
                            data-fancybox={`proj-construction-${i}`}
                          >
                            <img src={item.img} alt="" className="img-cover" />
                          </a>
                          <div className="info">
                            <div className="tags">
                              <a href="#"> {item.sub1} </a>
                              {item.sub2 ? <a href="#"> {item.sub2} </a> : null}
                            </div>
                            <h3 className="title">
                              <a href="#"> {item.title} </a>
                            </h3>
                            <div className="text">{item.desc}</div>
                          </div>

                          {item.imgs.map((img, index) => (
                            <a
                              key={`proj-construction-${i}-${index}`}
                              href={img}
                              className="img"
                              data-fancybox={`proj-construction-${i}`}
                              style={{ display: "none" }}
                            >
                              <img
                                src={img}
                                alt=""
                                className="img-cover"
                                loading="lazy"
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">
                  اضغط <br /> واسحب
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;
